import axios from 'axios';
import { getNonGwApiRoot } from '../../../constants/ParamountReactConstants';
import { ItemPackage } from '../../../../types/itemPackage';

export function updatePackage(params: ItemPackage[]) {
  // Process the params to set multi_box_number to "0" if it's null
  const processedParams = params.map(itemPackage => ({
    ...itemPackage,
    packages: itemPackage.packages.map(pkg => ({
      ...pkg,
      multi_box_number: pkg.multi_box_number === null ? '0' : pkg.multi_box_number,
    })),
  }));

  return {
    type: 'UPDATE_PACKAGE',
    payload: axios.patch(`${getNonGwApiRoot()}/v2/items/packages`, processedParams),
    meta: { itemPackages: processedParams },
  };
}
